import { render, staticRenderFns } from "./pwdChange.vue?vue&type=template&id=4c5d66c2&scoped=true"
import script from "./pwdChange.vue?vue&type=script&lang=js"
export * from "./pwdChange.vue?vue&type=script&lang=js"
import style0 from "./pwdChange.vue?vue&type=style&index=0&id=4c5d66c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5d66c2",
  null
  
)

export default component.exports